import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function LegalizacijaDalmacijaPage() {
  return (
    <div data-testid="legalizacija-dalmacija-page">
      <Seo
        title="Legalizacija Dalmacija"
        description="Legalizacija objekata u Dalmaciji: stručna priprema dokumentacije i vođenje postupka od Zadra do Dubrovnika."
        path="/legalizacija-dalmacija"
      />

      <section className="border-b border-hair">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-16 lg:pt-28 lg:pb-20">
          <div className="overline text-ink-soft">Djelokrug rada</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] font-bold text-ink mt-6">
            Legalizacija objekata<br />
            <span className="text-ink/40">u Dalmaciji</span>
          </h1>
          <p className="text-ink-soft leading-relaxed max-w-3xl mt-8">
            Pokrivamo područje cijele Dalmacije i vodimo postupke legalizacije za
            obiteljske kuće, pomoćne i gospodarske objekte, uz jasne rokove i
            transparentan proces.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-8">
        <article className="md:col-span-8 space-y-6 text-ink-soft leading-relaxed">
          <h2 className="font-display text-3xl text-ink">Lokalno znanje i iskustvo</h2>
          <p>
            Postupci legalizacije razlikuju se po gradovima i općinama, ovisno o
            prostornim planovima i praksi nadležnih tijela. Naš tim ima iskustvo
            rada na cijelom području Dalmacije.
          </p>
          <h2 className="font-display text-3xl text-ink">Tipični objekti</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>obiteljske kuće i stambeni objekti</li>
            <li>pomoćne zgrade (garaže, spremišta)</li>
            <li>gospodarski i poljoprivredni objekti</li>
          </ul>
        </article>

        <aside className="md:col-span-4 border border-hair p-6 bg-white h-fit">
          <div className="overline text-ink-soft">Zatražite procjenu</div>
          <p className="text-ink-soft mt-3 text-sm leading-relaxed">
            Pošaljite upit i dobit ćete prvi pregled mogućnosti legalizacije za
            vaš objekt.
          </p>
          <Link
            to="/prijava"
            className="inline-flex items-center gap-2 mt-5 bg-ink text-white px-5 py-3 text-sm font-medium rounded-sm hover:bg-[#112240] transition-colors"
          >
            Otvori prijavu
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
          </Link>
        </aside>
      </section>
    </div>
  );
}
